import useStyles from './styles';
import { IStarWithPartialFill } from './types';

function StarWithPartialFill({
  fillPercentage,
  baseColor = 'white',
  fillColor = fillPercentage == 0 ? 'white' : 'var(--x-accent-1-1)',
  strokeColor = fillPercentage == 0 ? 'var(--x-border-5)' : 'var(--x-accent-1-1)',
  strokeWidth = 1,
  index,
}: IStarWithPartialFill) {
  const classes = useStyles();
  const gradientId = `qt_star_gradient_${index}`;
  const fillUrl = `url(#${gradientId})`;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      className={classes.root}
    >
      <defs>
        <linearGradient id={gradientId}>
          <stop offset={Math.ceil(fillPercentage) + '%'} stopColor={fillColor} />
          <stop offset={Math.ceil(fillPercentage) + '%'} stopColor={baseColor} stopOpacity="1" />
        </linearGradient>
      </defs>
      <path
        d="M5.40625 5.48438C5.52083 5.46354 5.61979 5.42188 5.70312 5.35938C5.79688 5.28646 5.86979 5.20312 5.92188 5.10938L7.54688 1.625C7.64062 1.42708 7.79167 1.32812 8 1.32812C8.20833 1.32812 8.35938 1.42708 8.45312 1.625L10.0781 5.10938C10.1302 5.20312 10.1979 5.28646 10.2812 5.35938C10.375 5.42188 10.4792 5.46354 10.5938 5.48438L14.2344 6.03125C14.4427 6.0625 14.5781 6.18229 14.6406 6.39062C14.7031 6.59896 14.6615 6.77604 14.5156 6.92188L11.8594 9.64062C11.7865 9.71354 11.7344 9.80208 11.7031 9.90625C11.6719 10.0104 11.6615 10.1146 11.6719 10.2188L12.2969 14.0469C12.3385 14.2656 12.276 14.4375 12.1094 14.5625C11.9427 14.6875 11.7656 14.7031 11.5781 14.6094L8.32812 12.8125C8.22396 12.75 8.11458 12.7188 8 12.7188C7.88542 12.7188 7.77604 12.75 7.67188 12.8125L4.42188 14.6094C4.23438 14.7031 4.05729 14.6875 3.89062 14.5625C3.72396 14.4375 3.66146 14.2656 3.70312 14.0469L4.32812 10.2188C4.34896 10.1146 4.34375 10.0104 4.3125 9.90625C4.28125 9.80208 4.22396 9.71354 4.14062 9.64062L1.48438 6.92188C1.33854 6.77604 1.29688 6.59896 1.35938 6.39062C1.42188 6.18229 1.55729 6.0625 1.76562 6.03125L5.40625 5.48438Z"
        fill={fillUrl}
        strokeWidth={strokeWidth}
        stroke={strokeColor}
      />
    </svg>
  );
}

export default StarWithPartialFill;
